import { useEffect, useState } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StockPicksGraph = () => {
    const [data, setData] = useState([]);
    const theme = useTheme();

    useEffect(() => {
        fetch('/cg_track_record.json')
            .then(response => response.json())
            .then(jsonData => {
                const formatted = jsonData.map(entry => ({
                    date: new Date(entry.date).toLocaleDateString('default', { month: 'short', year: 'numeric' }),
                    'Capitol Gains': entry.capitol_gains,
                    'S&P 500': entry.SP500,
                }));
                setData(formatted);
            })
            .catch(err => console.error('Error loading track record:', err));
    }, []);

    return (
        <Box sx={{ height: 480 }}>
            <ResponsiveBar
                data={data}
                keys={['Capitol Gains', 'S&P 500']}
                indexBy="date"
                margin={{ top: 20, right: 120, bottom: 70, left: 50 }}
                padding={0.25}
                groupMode="grouped"
                colors={[theme.palette.primary.main, theme.palette.custom.direction.sellFg]}
                borderRadius={3}
                enableLabel={false}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 6,
                    tickRotation: 45,
                    legend: 'Investment date',
                    legendPosition: 'middle',
                    legendOffset: 55,
                    tickValues: data.filter((_, i) => i % 3 === 0).map(d => d.date),
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    legend: '1-year ROI',
                    legendPosition: 'middle',
                    legendOffset: -40,
                    format: v => `${v}%`,
                }}
                gridYValues={5}
                tooltip={({ id, value, indexValue }) => {
                    const found = data.find(d => d.date === indexValue);
                    const diff = found ? (found['Capitol Gains'] - found['S&P 500']).toFixed(1) : null;
                    return (
                        <Box sx={{
                            bgcolor: 'custom.surface.elevated',
                            p: 1.25,
                            borderRadius: 1,
                            border: t => `1px solid ${t.palette.custom.border.default}`,
                            minWidth: 180,
                        }}>
                            <Typography variant="caption" sx={{ color: 'text.muted', display: 'block' }}>
                                {indexValue}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: id === 'Capitol Gains' ? theme.palette.primary.main : theme.palette.custom.direction.sellFg }}>
                                {id}: {value}%
                            </Typography>
                            {diff && (
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    Difference: {diff}%
                                </Typography>
                            )}
                        </Box>
                    );
                }}
                legends={[{
                    dataFrom: 'keys',
                    anchor: 'top-right',
                    direction: 'column',
                    translateX: 110,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemsSpacing: 4,
                    symbolShape: 'square',
                    symbolSize: 10,
                    itemTextColor: theme.palette.text.secondary,
                }]}
                theme={{
                    axis: {
                        domain: { line: { stroke: theme.palette.custom.border.subtle } },
                        ticks: {
                            line: { stroke: theme.palette.custom.border.subtle },
                            text: { fill: theme.palette.text.secondary, fontSize: 11, fontFamily: theme.typography.fontFamily },
                        },
                        legend: { text: { fill: theme.palette.text.secondary, fontSize: 12 } },
                    },
                    grid: { line: { stroke: theme.palette.custom.border.subtle } },
                    legends: { text: { fill: theme.palette.text.secondary } },
                }}
            />
        </Box>
    );
};

export default StockPicksGraph;
